export interface Country {
  /** Phone country code without the leading +, e.g. "221" for Senegal. */
  id: string;
  /** Display name. */
  name: string;
  /** ISO 3166-1 alpha-2 country code (lowercase), e.g. "sn" for Senegal. */
  iso2: string;
  /** Flag emoji. */
  flag: string;
}

// Single source of truth for the country list shared between PhoneNumberInput
// (which keys by phone code) and LocationPicker (which keys by ISO alpha-2
// for Google Places). Adding a new country here makes it available in both.
//
// `id` is kept as the phone code for backwards compatibility with the
// existing PhoneNumberInput consumers.
export const COUNTRIES: Country[] = [
  { id: '221', name: 'Senegal', iso2: 'sn', flag: '🇸🇳' },
  { id: '1', name: 'USA', iso2: 'us', flag: '🇺🇸' },
  { id: '33', name: 'France', iso2: 'fr', flag: '🇫🇷' },
  { id: '971', name: 'UAE', iso2: 'ae', flag: '🇦🇪' },
];

export const NO_PAGE_LIMIT = 0;
export const DEFAULT_PAGE_LIMIT = 10;
export const DEFAULT_PAGE_OFFSET = 0;

// Calculate item number for paginated lists (1-indexed)
export const getItemNumber = (
  index: number,
  page: number,
  pageLimit: number = DEFAULT_PAGE_LIMIT
): number => {
  return (page - 1) * pageLimit + index + 1;
};

export const MAX_TEMPLATE_NAME_LENGTH = 512;
export const MAX_TEMPLATE_HEADER_LENGTH = 60;
export const MAX_TEMPLATE_FOOTER_LENGTH = 60;
export const MAX_TEMPLATE_BODY_LENGTH = 1024;
export const MAX_TEMPLATE_BUTTON_LENGTH = 25;

export const MESSAGE_STATUS_POLL_INTERVAL_MS = parseInt(
  process.env.REACT_APP_MESSAGE_STATUS_POLL_INTERVAL_MS || '30000',
  10
);
